import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  MOBILE,
  FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  FETCH_COORDINATOR_GROUPS_FOR_NETWORK_REQUEST,
  FETCH_COORDINATOR_GROUPS_FOR_NETWORK_SUCCESS,
  FETCH_COORDINATOR_GROUPS_FOR_NETWORK_ERROR,
} from './coordinator-groups-actions';


const defaultState = {
  mobile: {
    groups: [],
    fetching: false,
  },
  fixed: {
    groups: [],
    fetching: false,
  },
};

// check that the network passed in is a recognised value
// also do a console.warn as we shouldn't be passing incorrect network types to the reducer
const networkValid = (network) => {
  if (![MOBILE, FIXED].includes(network)) {
    console.warn(`Unrecoginsed network: ${network}`);
    return false;
  }
  return true;
};

// generate an action handler that sets fetching value for the network
// function accepts the value desired for fetching
const setFetchingForNetwork = (fetching) => (state, action) => {
  const { network } = action.payload;
  // if for some reason network isn't one of 'mobile' or 'fixed' return state and warn
  if (!networkValid(network)) {
    return state;
  }
  return ({
    ...state,
    [network]: {
      ...state[network],
      fetching,
    },
  });
};

const updateGroupsForNetwork = (state, action) => {
  const { network, groups } = action.payload;
  // if for some reason network isn't one of 'mobile' or 'fixed' return state and warn
  if (!networkValid(network)) {
    return state;
  }
  return ({
    ...state,
    [network]: {
      ...state[network],
      groups,
      fetching: false,
    },
  });
};

const actionHandlers = {
  [FETCH_COORDINATOR_GROUPS_FOR_NETWORK_REQUEST]: setFetchingForNetwork(true),
  [FETCH_COORDINATOR_GROUPS_FOR_NETWORK_ERROR]: setFetchingForNetwork(false),
  [FETCH_COORDINATOR_GROUPS_FOR_NETWORK_SUCCESS]: updateGroupsForNetwork,
};

const coordinatorGroupsReducer = createReducer(defaultState, actionHandlers);

export {
  coordinatorGroupsReducer,
  defaultState,
};

